module.exports = __webpack_public_path__ + "img/4-4.7c62f5f5.svg";